/**
 * @var service.ready
 * @var service.banners
 * @param grecaptcha
 * @param variables {{ recaptcha: object, profiles: object }}
 */
const CommentsController =  ['$scope', '$http', '$modules', function($scope, $http, $modules) {

    $scope.reply = {
        id: 0,
        comment: '',
        reply_comment: '',
        nickname: '',
        loading: false,
        error: '',
    };

    $scope.actions = {
        comments: {
            reply: function ( id ) {
                $scope.reply = {
                    id: typeof id !== "undefined" ? id : 0,
                    comment: '',
                    reply_comment: '',
                    nickname: '',
                    loading: false,
                    error: '',
                };
            },
            post: function () {
                $scope.reply.loading = true;

                if($scope.reply.reply_comment !== '') {
                    $scope.reply.comment = $scope.reply.reply_comment;
                    $scope.reply.reply_comment = '';
                }

                $http.post( $scope.service.comments.create, $scope.reply ).then(function ( response ) {
                    if ( response.data.success ) {
                        $scope.service.comments.items = response.data.comments;
                        $scope.reply = {
                            id: 0,
                            comment: '',
                            reply_comment: '',
                            nickname: '',
                            loading: false,
                            error: '',
                        };
                        $scope.service.comments.needsNickname = false;
                    } else {
                        $scope.reply.error = response.data.service.message;
                    }
                    $scope.reply.loading = false;

                });
            },
            delete: function ( link ) {
                if ( window.confirm("Are you sure you want to delete this comment ?") ) {
                    $http.get( link, $scope.reply ).then(function ( response ) {
                        if ( response.data.success ) {
                            $scope.service.comments.items = response.data.comments;
                        }
                    });
                }
            }

        }

    };

}];

export default CommentsController;
